<template>
  <div class="w-full">
    <h2 class="text-2xl text-primary leading-10 font-inter font-bold tracking-tight mb-6">
      Family
    </h2>
    <div class="flex flex-col gap-6">
      <div class="w-full">
        <label :class="labelClass" for="maritalStatus">Marital Status</label>
        <DsDropdown
          id="maritalStatus"
          name="maritalStatus"
          v-model="maritalStatusValue"
          :options="maritalStatuses"
          placeholder="Select an option"
        />
      </div>

      <div class="w-full">
        <span :class="labelClass">Do you have kids?</span>
        <div class="w-full flex gap-2">
          <DsRadioCard
            v-for="item in haveKids"
            :key="String(item.value)"
            class="flex-1"
            name="haveChildren"
            align="center"
            hide-indicator
            :label="item.label"
            :value="item.value"
            :model-value="payload.haveChildren"
            @update:modelValue="onHaveKids"
          />
        </div>
      </div>

      <div v-if="payload.haveChildren === true" class="w-full">
        <label :class="labelClass" for="numberOfChildren">How many kids do you have?</label>
        <DsDropdown
          id="numberOfChildren"
          name="numberOfChildren"
          v-model="numberOfChildrenValue"
          :options="kidsCountOptions"
          placeholder="Select an option"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  Dropdown as DsDropdown,
  RadioCard as DsRadioCard,
} from '@team-hogc/hogc-one-design-system';
import { maritalStatuses } from '@/constants/register/maritalStatuses';

const MAX_KIDS = 10;

export default {
  components: {
    DsDropdown,
    DsRadioCard,
  },
  props: {
    payload: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      haveKids: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      maritalStatuses,
      // The dropdown matches option values by identity, so the count is held
      // as a string here and written back to the payload as a number.
      kidsCountOptions: Array.from({ length: MAX_KIDS }, (_, index) => ({
        label: String(index + 1),
        value: String(index + 1),
      })),
      labelClass: 'text-base text-primary font-inter font-medium block mb-1 leading-5',
    };
  },
  computed: {
    maritalStatusValue: {
      get() {
        return this.payload.maritalStatus || '';
      },
      set(value) {
        this.payload.maritalStatus = value || null;
      },
    },
    numberOfChildrenValue: {
      get() {
        const value = this.payload.numberOfChildren;
        return value === null || value === undefined ? '' : String(value);
      },
      set(value) {
        this.payload.numberOfChildren = value === '' ? null : Number(value);
      },
    },
  },
  watch: {
    'payload.haveChildren'(newVal, oldVal) {
      if (newVal === true) {
        if (this.payload.numberOfChildren === null || this.payload.numberOfChildren === undefined) {
          this.payload.numberOfChildren = 1;
        }
      } else if (newVal === false && oldVal === true) {
        // When haveChildren changes to false, reset numberOfChildren
        this.payload.numberOfChildren = null;
      }
    },
  },
  methods: {
    onHaveKids(value) {
      this.payload.haveChildren = value;
    },
  },
};
</script>
